<template lang="pug">
.v-socials.socials(v-if="socials")
	template(v-if="socials.items && socials.items.length")
		.socials__items
			template(v-for="(item, index) in socials.items" :key="index")
				a.socials__item(:href="item.link" :aria-label="item.text" target='_blank')
					img.socials__item-image(:src="item.image" alt="" loading="lazy")

	.socials__images()
		.socials__image(v-for="(item, index) of 2" :key="index")
			img(:src="`/local/assets/images/${isRuRegion ? 'ru-' : ''}bottom-${index+1}.png`" alt="" loading="lazy")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			socials: null,
			isRuRegion: null
		};
	},

	mounted() {
		this.isRuRegion = document.querySelector('.region-ru');
	},

	methods: {
		dataSet(data) {
			this.socials = data;
		}
	}
};
</script>
